module.exports = __webpack_public_path__ + "img/u21.60d37c30.png";